<template>
    <div class="py-2 flex justify-between">
        <div class="mb-2 main-text-color">
            <span class="text-main-sm whitespace-nowrap main-text-color">
                {{ makePrefixForTranslation(LayoutParameterName) }}:
            </span>
        </div>
        <el-select :placeholder="$t('general.account')" v-model="sound" size="small" class="sound-select">
            <el-option :key="option.value" :value="option.value" :label="option.label" v-bind="option" v-for="option in sounds">
                <SoundSelector
                    @click.prevent
                    :sound-id="option.soundId"
                    :src="option.sound"
                 />
            </el-option>
        </el-select>
    </div>
</template>
<script>
    import { Option, Select} from 'element-ui'
    import SoundSelector from './SoundSelector.vue'

    export default {
        name: 'SingleSoundSelector',
        props: {
            value: {
                required: true
            },
            LayoutParameterName: {
                type: String,
                default: '',
            },
        },
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            SoundSelector
        },
        data() {
            return {
                sounds: [],
                sound: null
            }
        },
        computed: {
            warningSounds () {
                return this.$store.getters['entities/getWarningSounds']
            },
            errorSounds () {
                return this.$store.getters['entities/getErrorSounds']
            }
        },
        async mounted() {
            this.makeSoundList()
            if (this.value) {
                this.sound = this.value
            } else {
                this.sound = this.LayoutParameterName === 'SoundError' ? 'default-error' : 'default-warning'
            }
        },
        methods: {
            makePrefixForTranslation (string) {
                const makeFirstLetterInLowerCase = (string) => string.charAt(0).toLowerCase() + string.slice(1)
                return this.$t(`layout.config.${makeFirstLetterInLowerCase(string)}`)
            },
            makeSoundList () {
                this.sounds = this.LayoutParameterName === 'SoundError' ? this.errorSounds : this.warningSounds
            }
        },
        watch: {
            sound (val) {
                if (val) {
                    this.$emit('update:value', val)
                }
            }
        }
    }
</script>

<style>
.sound-select {
    width: 180px;
}
</style>